import React from 'react'

function Preloader() {
  return (
    <div className='preloader'>
      Preloader
    </div>
  )
}

export default Preloader
